import { Coordinates } from "@soft-db/monitoring-api-client";

const EarthRadius = 6371.071;

// Given two coordinates, compute the distance between them in KM
export function haversineDistance(a: Coordinates, b: Coordinates) {
	const rlat1 = a.latitude * (Math.PI / 180); // Convert degrees to radians
	const rlat2 = b.latitude * (Math.PI / 180); // Convert degrees to radians
	const difflat = rlat2 - rlat1; // Radian difference (latitudes)
	const difflon = (b.longitude - a.longitude) * (Math.PI / 180); // Radian difference (longitudes)

	const d =
		2 *
		EarthRadius *
		Math.asin(
			Math.sqrt(
				Math.sin(difflat / 2) * Math.sin(difflat / 2) +
					Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
			)
		);
	return d;
}
